// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".audio-preview--v_uO6{width:100%;border-radius:8px;background-color:#fafafb}.form-field--zl11J{flex:1 1 0;min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audio-preview": "audio-preview--v_uO6",
	"form-field": "form-field--zl11J"
};
export default ___CSS_LOADER_EXPORT___;
